module.exports = __webpack_public_path__ + "img/App.e4a282e3.png";